import React from "react";
import { METRICS } from "@/data/portfolio";

export const Stats = () => {
  return (
    <section
      id="impact"
      data-testid="stats-section"
      className="bg-background"
    >
      <div className="max-w-3xl mx-auto px-6 py-10">
        <h2 className="font-serif text-2xl md:text-3xl text-foreground mb-1">
          A few numbers
        </h2>
        <p className="text-sm text-quiet mb-8">
          Production metrics from systems I've built or maintain today.
        </p>

        <dl className="grid grid-cols-2 sm:grid-cols-3 gap-y-6 gap-x-8">
          {METRICS.map((m) => (
            <div key={m.label} data-testid={m.testid}>
              <dt className="font-serif text-3xl md:text-4xl text-foreground font-medium">
                {m.value}
              </dt>
              <dd className="mt-1 text-sm text-foreground/85">{m.label}</dd>
              <dd className="text-xs text-quiet mt-0.5">{m.note}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
};
